<template>
  <div class="index">
    <div class="index-con">
      <div class="title">
        ANNOUNCEMENT | Inaugural Meeting of International Research Association
        for Drying Science & Technology (Macao)
      </div>
      <div class="title_up">—— Updated September 23, 2024</div>
      <div class="text">
        The International Research Association for Drying Science and Technology
        (Macao) (IRADSTM) has been officially registered in Macao. In
        conjunction with IDS 2024, we are organizing the inaugural annual
        meeting of IRADSTM. 
        <br />
        <br />
        <b>IRADSTM Event Details：</b>
        <br />
        <b>Date</b>: Nov.21-22, 2024 (A day before IDS 2024 start)
        <br />
        <b>Location</b>: Worldhotel Grand Juna Wuxi (Same venue as IDS 2024)
        <br />
        <br />
        We look forward to seeing you in the 2024 Annual Meeting.
        <br />
      </div>
      <br />
      <br />
      <div>
        <a target="_blank" class="text-url" href="http://dx.doi.org/10.1080/07373937.2024.2406170">
          http://dx.doi.org/10.1080/07373937.2024.2406170
        </a>
        <iframe style="
            width: 100%;
            margin-top: 20px;
            min-height: 800px;
            margin-bottom: 20px;
          " src="https://www.maiqs2026.org/index/public/file海报.pdf" frameborder="0"></iframe>
        If you are unable to view this PDF file online, you can download this <span class="text-url cup"
          @click="downFn">PDF file</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    downFn() {
      let href =
        "https://www.maiqs2026.org/index/public/file海报.pdf";
      var a = document.createElement("a");
      a.href = href;
      a.download = `Inaugural Meeting of International Research Association for Dryi.pdf`;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
  }
};
</script>

<style scoped>
.index {
  margin-bottom: 100px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  min-height: 500px;
}

.text-url {
  color: rgb(30, 98, 222);
  font-weight: 600;
}

.title {
  font-size: 24px;
  color: #0a9a7a;
  font-weight: 600;
  text-align: center;
  margin: 50px 0 40px;
}

.title_up {
  font-size: 18px;
  color: #000;
  font-weight: 600;
  text-align: right;
}

.text {
  font-weight: 400;
  line-height: 24px;
  margin-top: 30px;
}

.book-right .text {
  margin-top: 0;
}

.text-1 {
  text-indent: 0;
  padding-left: 2em;
  box-sizing: border-box;
  position: relative;
}

.book-lists {
  margin-top: 40px;
  border-top: 1px solid #000;
  padding: 20px 10px 150px;
  box-sizing: border-box;
}

.book-list {
  display: flex;
  margin-top: 40px;
}

.img1 {
  width: 100px;
  height: auto;
}

.img2 {
  height: 60px;
  width: auto;
  flex-shrink: 0;
}

.book-right {
  flex: 1;
  margin-left: 20px;
}

.text-1::after {
  content: "";
  left: 0;
  top: 8px;
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #333;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
    padding: 40px 10px 10px;
    box-sizing: border-box;
  }

  .img1,
  .img2 {
    width: 50%;
    display: block;
    margin: 0 auto 20px;
    height: auto;
  }

  .book-list {
    display: block;
  }

  .book-right {
    margin-left: 0;
  }

  .text-url {
    width: 100%;
    display: block;
    margin-top: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newsDetail8.vue